import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Filtering, QBox, QSelect, QSelectItem } from '@qualio/ui-components';

type StatusFilterV2Props = {
  filterOptions: QSelectItem<string, string>[];
  setTemplateStatuses: React.Dispatch<React.SetStateAction<string>>;
};

export const StatusFilterV2: React.FC<StatusFilterV2Props> = ({ filterOptions, setTemplateStatuses }) => {
  const { t } = useTranslation();
  const filtering = Filtering.useFiltering();
  const initialValue = filtering.filters.status?.value;

  useEffect(() => {
    if (initialValue) {
      setTemplateStatuses(initialValue);
    }
  }, [initialValue, setTemplateStatuses]);

  const onStatusChange = useCallback(
    (status: QSelectItem | null) => {
      if (status) {
        filtering.setFilters({
          status: status.value,
        });
        setTemplateStatuses(status.value);
      }
    },
    [setTemplateStatuses, filtering],
  );

  return (
    <QBox w="200px">
      <QSelect
        options={filterOptions}
        onChange={onStatusChange}
        value={filtering.filters.status?.value}
        data-cy="template-status-filter"
        aria-label={t('template.list.filters.status.ariaLabel')}
      />
    </QBox>
  );
};
